var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title)?_c('div',{staticClass:"comp-title comp"},[_c('div',{staticClass:"title"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }